import { CycleUtils } from '@wix/package-picker-shared';
import { useCurrentModule } from '../components/ModuleProvider';
export const useViewChange = () => {
  const module = useCurrentModule();
  const {
    setSelectedProductId,
    setSelectedCycleId
  } = module.SDK.PackagePickerStore;
  const changeRoute = module.internals.hooks.useChangeRoute();
  const handleViewChange = (step, params) => {
    if (params != null && params.productId) {
      setSelectedProductId(params.productId);
    }
    if (params != null && params.cycleId) {
      setSelectedCycleId(CycleUtils.validateCycleId(params.cycleId));
    }
    changeRoute(step);
  };
  return handleViewChange;
};
//# sourceMappingURL=useViewChange.js.map